/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RetailerAddress,
} from '../models/index';
import {
    RetailerAddressFromJSON,
    RetailerAddressToJSON,
} from '../models/index';

/**
 * 
 */
export class RetailerAddressResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getRetailerShippingAddresses without sending the request
     */
    async getRetailerShippingAddressesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/retailer/address/shipping`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getRetailerShippingAddressesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RetailerAddress>>> {
        const requestOptions = await this.getRetailerShippingAddressesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RetailerAddressFromJSON));
    }

    /**
     */
    async getRetailerShippingAddresses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RetailerAddress>> {
        const response = await this.getRetailerShippingAddressesRaw(initOverrides);
        return await response.value();
    }

}
